const announcementsMock = [
    {
        objectID: '6',
        created_at_timestamp: 1746057600,
        title: 'Lorem 6',
        subject: 'Subject Line Lorem 6',
        body: `Salutations Trustees,
            <br /><br />Lorem ipsum dolor sit amet consectetur. Sagittis posuere urna faucibus venenatis neque dictumst. Arcu non massa non ultrices. Arcu cursus nisi praesent tellus. Quis cursus nec volutpat id blandit euismod. Faucibus sed et odio ut mollis iaculis vitae id hendrerit. Facilisi placerat commodo mattis dui tempus. Vestibulum et ante purus nec massa pretium. Nullam laoreet in mauris adipiscing sit in sit vivamus mauris. Nec ultrices non aliquet integer aliquet potenti feugiat risus vitae. Commodo etiam proin sit vitae dictum arcu libero a consequat.
            <br /><br />A et lorem tellus consectetur. Tellus odio amet posuere quis erat massa libero etiam. Eu volutpat ipsum vulputate donec vitae nisi sed. Vitae nec natoque venenatis consequat dolor erat eget elementum. Quam tellus dolor commodo pretium odio diam scelerisque feugiat sed. Tempus.
            <br /><br />Lorem ipsum dolor sit amet consectetur. Sagittis posuere urna faucibus venenatis neque dictumst. Arcu non massa non ultrices. Arcu cursus nisi praesent tellus. Quis cursus nec volutpat id blandit euismod. Faucibus sed et odio ut mollis iaculis vitae id hendrerit. Facilisi placerat commodo mattis dui tempus. Vestibulum et ante purus nec massa pretium. Nullam laoreet in mauris adipiscing sit in sit vivamus mauris. Nec ultrices non aliquet integer aliquet potenti feugiat risus vitae. Commodo etiam proin sit vitae dictum arcu libero a consequat.
            <br /><br />A et lorem tellus consectetur. Tellus odio amet posuere quis erat massa libero etiam. Eu volutpat ipsum vulputate donec vitae nisi sed. Vitae nec natoque venenatis consequat dolor erat eget elementum. Quam tellus dolor commodo pretium odio diam scelerisque feugiat sed. Tempus.
            <br /><br />Arcu cursus nisi praesent tellus. Quis cursus nec volutpat id blandit euismod. Faucibus sed et odio ut mollis iaculis vitae id hendrerit. Facilisi placerat commodo mattis dui tempus.
            <br /><br />Looking forward to it,
            <br />Angele Robinson-Gaylord 
            <br />Chairman of the Executive Board Committee`,
    },
    {
        objectID: '5',
        created_at_timestamp: 1742256000,
        title: 'Lorem 5',
        subject: 'Subject Line Lorem 5',
        body:
            'Quis copiosae intellegebat ea pri, vivendo minimum iracundia sit ei? In cum nihil invenire, his eu meis congue constituam! Vidisse docendi forensibus vix ea, nam ut solet ignota eloquentiam. Reque solet offendit ius ut, mel summo accumsan omnesque cu. Pro omnesque iudicabit repudiare et.',
    },
    {
        objectID: '4',
        created_at_timestamp: 1741564800,
        title: 'Lorem 4',
        subject: 'Subject Line Lorem 4',
        body:
            'Mea mutat fugit voluptua te, pri vide principes te? Deleniti lucilius maluisset ea mei, at vix mazim suavitate. At dico quando consetetur cum, est eripuit nominavi no, ad oblique forensibus per? Sed te ludus utinam iisque, mea ex vocent fabulas maiestatis, unum euismod est ne. Vel id viris deleniti conclusionemque.',
    },
    {
        objectID: '3',
        created_at_timestamp: 1738886400,
        title: 'Lorem 3',
        subject: 'Subject Line Lorem 3',
        body:
            'Duo eu vide velit doctus? Has an choro tamquam, mel putant debitis referrentur te, at pri malis libris? Eos ei impedit expetendis cotidieque, te his rebum detracto expetendis, sed rebum suscipiantur eu. Ei sale omittam luptatum eos, prompta voluptatibus ut mei, vix te reque dicat. Ad unum putent dissentiunt usu, veritus civibus singulis ex duo.',
    },
    {
        objectID: '2',
        created_at_timestamp: 1734912000,
        title: 'Lorem 2',
        subject: 'Subject Line Lorem 2',
        body:
            'Vim ea quodsi tamquam, ea vim graece diceret. Eum eu luptatum argumentum appellantur. Case senserit an eam, id amet petentium expetenda quo, dolorum oporteat adipisci vis an? Ne altera animal eleifend vis, vim mucius assentior ut. Vim ex discere admodum laboramus, te per facete nusquam. At diam solum facilisi cum, cu cetero saperet rationibus per, vis an docendi urbanitas!',
    },
    {
        objectID: '1',
        created_at_timestamp: 1730419200,
        title: 'Lorem 1',
        subject: 'Subject Line Lorem 1',
        body:
            'Lorem ipsum dolor sit amet, eos ne amet commodo. Ut saepe feugiat ius! Qui dicant civibus ex, at sint assueverit eos. Ad admodum fastidii iracundia qui. Vis integre definitiones te, te fastidii singulis eam, officiis detraxit facilisis quo an!',
    },
];

export default announcementsMock;
